import React, { useState } from 'react'
import ProjectBaseForm from './ProjectBaseForm'
import EmailForm from './EmailToTheForemanForm'
import { Project } from '../../types'

interface DeviceInstallProjectCreationProps {
  afterCreate?: (project: Project) => void
  onCancel?: () => void
}

export default function DeviceInstallProjectCreation({
  afterCreate,
  onCancel
}: DeviceInstallProjectCreationProps) {
  /**
   * The project that was created.
   */
  const [project, setProject] = useState<Project>()

  function handleAfterSubmit(project: Project) {
    setProject(project)
  }

  function handleEmailSent() {
    if (project) {
      afterCreate?.(project)
    }
  }

  return (
    <React.Fragment>
      {project ? (
        <EmailForm projectId={project.id} emailSent={handleEmailSent} />
      ) : (
        <ProjectBaseForm afterSubmit={handleAfterSubmit} onCancel={onCancel} />
      )}
    </React.Fragment>
  )
}
